import React from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "../theme";
import { useCurrencyFormatter } from "../../../../Components/Hooks/useCurrencyFormatter";

const ContractUnits = ({ units = [], contract }) => {
  const navigate = useNavigate();
  const { formatCurrency } = useCurrencyFormatter();

  return (
    <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 14, overflow: "hidden" }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 10, padding: "16px 18px 14px" }}>
        <h2 style={{ margin: 0, fontSize: 15.5, fontWeight: 650, letterSpacing: "-0.2px" }}>Units</h2>
        <span style={{ fontSize: 13, color: theme.textMuted }}>
          {units.length} associated
          {contract?.total_contract_value
            ? ` · settlement ${formatCurrency(contract.total_contract_value, "EUR")}`
            : ""}
        </span>
      </div>

      <div style={{ borderTop: "1px solid #eeeef2" }}>
        {units.length === 0 ? (
          <div style={{ padding: 24, textAlign: "center", color: theme.textMuted, fontSize: 13.5 }}>
            No units found for this contract
          </div>
        ) : (
          units.map((unit, index) => {
            const settledPrice = unit.settlement_price?.settled_price ?? unit.initial_price;
            const rate = unit.net_sqm ? settledPrice / unit.net_sqm : null;

            return (
              <div
                key={unit.id}
                onClick={() => navigate(`/unit-details/${unit.id}`)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  padding: "15px 18px",
                  borderBottom: index < units.length - 1 ? "1px solid #f2f2f6" : "none",
                  flexWrap: "wrap",
                  cursor: "pointer",
                }}
              >
                <div style={{ flex: "none", width: 38, height: 38, borderRadius: 10, background: theme.neutralBadgeBg }}></div>
                <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 14.5,
                      fontWeight: 600,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {unit.block}, Unit {unit.nr}
                  </div>
                  <div style={{ fontSize: 12.5, color: theme.textMuted, marginTop: 2 }}>
                    {unit.type}
                    {unit.net_sqm ? ` · ${unit.net_sqm} sq.m` : ""}
                  </div>
                </div>
                {rate !== null && (
                  <div style={{ flex: "0 1 auto", textAlign: "right", minWidth: 72 }}>
                    <div style={{ fontSize: 12, color: theme.textMuted }}>€/sq.m</div>
                    <div style={{ fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                      {formatCurrency(rate, "EUR")}
                    </div>
                  </div>
                )}
                <div style={{ flex: "0 1 auto", textAlign: "right", minWidth: 96 }}>
                  <div style={{ fontSize: 12, color: theme.textMuted }}>Settlement</div>
                  <div style={{ fontSize: 15, fontWeight: 650, fontVariantNumeric: "tabular-nums" }}>
                    {formatCurrency(settledPrice, "EUR")}
                  </div>
                  {/* Extras are stored separately from the settled price and
                      add to the unit's total (the header total includes them). */}
                  {unit.settlement_price?.extra_finishing > 0 && (
                    <div style={{ fontSize: 12, color: theme.textMuted, marginTop: 1, fontVariantNumeric: "tabular-nums" }}>
                      + {formatCurrency(unit.settlement_price.extra_finishing, "EUR")} extra
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default React.memo(ContractUnits);
